<p-table [value]="allPaymentLinesControls" styleClass="p-datatable-sm" responsiveLayout="stack"
	[loading]="!paymentsGroup">
	<ng-template pTemplate="header">
		<tr>
			<th>{{ 'modals.cashPayment.table.type' | translate }}</th>
			<th>{{ 'modals.cashPayment.table.date' | translate }}</th>
			<th>{{ 'modals.cashPayment.table.details' | translate }}</th>
			<th>{{ 'modals.cashPayment.table.amount' | translate }}</th>
			<th style="width: 80px;">{{ 'routes.document.actions' | translate }}</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-paymentLine let-i="rowIndex">
		<tr>
			<td>
				<span class="p-column-title">{{ 'modals.cashPayment.table.type' | translate }}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CASH'">{{ 'modals.cashPayment.table.cash' | translate
					}}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CHK'">{{ 'modals.cashPayment.table.check' | translate
					}}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'BT'">{{ 'modals.cashPayment.table.bankTransfer' |
					translate }}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CC'">{{ 'modals.cashPayment.table.creditCard' | translate
					}}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'DEDUCTION'">{{ 'modals.cashPayment.table.deduction' | translate }}</span>
			</td>
			<td>
				<span class="p-column-title">{{ 'modals.cashPayment.table.date' | translate }}</span>
				<span *ngIf="paymentLine.get('date')">
					{{ paymentLine.get('date')?.value | date:'dd/MM/yyyy' }}
				</span>
				<span *ngIf="!paymentLine.get('date')">-</span>
			</td>
			<td>
				<span class="p-column-title">{{ 'modals.cashPayment.table.details' | translate }}</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CHK'">
					{{ 'modals.cashPayment.table.checkNumber' | translate }}: {{ paymentLine.get('check')?.value || '-'
					}} |
					{{ 'modals.cashPayment.table.bank' | translate }}: {{ paymentLine.get('bank')?.value || '-' }} |
					{{ 'modals.cashPayment.table.accountNumber' | translate }}: {{ paymentLine.get('account')?.value ||
					'-' }}
				</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'BT'">
					{{ 'modals.cashPayment.table.bank' | translate }}: {{ paymentLine.get('bank')?.value || '-' }} |
					{{ 'modals.cashPayment.table.accountNumber' | translate }}: {{ paymentLine.get('account')?.value ||
					'-' }}
				</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CC'">
					{{ 'modals.cashPayment.table.type' | translate }}: {{ paymentLine.get('credit_card_name')?.value ||
					'-' }} |
					{{ 'modals.cashPayment.table.code' | translate }}: {{ paymentLine.get('credit_card_code')?.value ||
					'-' }} |
					{{ 'modals.cashPayment.table.accountNumber' | translate }}: {{ paymentLine.get('account')?.value ||
					'-' }}
				</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'DEDUCTION'">-</span>
				<span *ngIf="paymentLine.paymentTypeCode === 'CASH'">-</span>
			</td>
			<td>
				<span class="p-column-title">{{ 'modals.cashPayment.table.amount' | translate }}</span>
				{{ paymentLine.get('amount')?.value | number:'1.2-2' }}
			</td>
			<td class="d-flex gap-2">
				<span class="p-column-title">{{ 'routes.document.actions' | translate }}</span>
				<button pButton pRipple type="button" icon="pi pi-pencil"
					class="p-button-rounded p-button-warning p-button-text"
					(click)="openEditPaymentDialog(paymentLine.paymentTypeCode, i)" [disabled]="!paymentsGroup"
					[title]="'modals.common.edit' | translate"></button>
				<button pButton pRipple type="button" icon="pi pi-trash"
					class="p-button-rounded p-button-danger p-button-text"
					(click)="removeLine(paymentLine.paymentTypeCode, i)" [disabled]="!paymentsGroup"
					[title]="'modals.common.delete' | translate"></button>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="5">
				<span *ngIf="!paymentsGroup">{{ 'modals.cashPayment.table.loading' | translate }}</span>
				<span *ngIf="paymentsGroup">{{ 'modals.cashPayment.table.noLines' | translate }}</span>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="footer">
		<tr class="fw-bold">
			<td colspan="3" class="text-end">{{ 'modals.cashPayment.table.totalPayments' | translate }}:</td>
			<td class="text-start">
				<span class="p-column-title">{{ 'modals.cashPayment.table.amount' | translate }}</span>
				{{ (lastEmittedTotals?.cash ?? 0) + (lastEmittedTotals?.checks ?? 0) + (lastEmittedTotals?.bank ??
				0) + (lastEmittedTotals?.credit ?? 0) + (lastEmittedTotals?.deduction ?? 0) | number:'1.2-2' }}
			</td>
			<td>
				<span class="p-column-title">{{ 'routes.document.actions' | translate }}</span>
			</td>
		</tr>
		<!-- Adjust colspans if using individual totals -->
		<!--
		<tr *ngIf="lastEmittedTotals?.cash ?? 0 > 0">
			<td colspan="3" class="text-end">{{ 'Total Cash' | translate }}:</td>
			<td>{{ lastEmittedTotals?.cash | number:'1.2-2' }}</td>
			<td></td>
		</tr>
		<tr *ngIf="lastEmittedTotals?.checks ?? 0 > 0">
			<td colspan="3" class="text-end">{{ 'Total Checks' | translate }}:</td>
			<td>{{ lastEmittedTotals?.checks | number:'1.2-2' }}</td>
			<td></td>
		</tr>
		<tr *ngIf="lastEmittedTotals?.bank ?? 0 > 0">
			<td colspan="3" class="text-end">{{ 'Total Bank Transfer' | translate }}:</td>
			<td>{{ lastEmittedTotals?.bank | number:'1.2-2' }}</td>
			<td></td>
		</tr>
		<tr *ngIf="lastEmittedTotals?.credit ?? 0 > 0">
			<td colspan="3" class="text-end">{{ 'Total Credit Card' | translate }}:</td>
			<td>{{ lastEmittedTotals?.credit | number:'1.2-2' }}</td>
			<td></td>
		</tr>
		-->
	</ng-template>
</p-table>

<div class="p-3 d-flex flex-wrap gap-2 add-payments">
	<button type="button" pButton pRipple icon="pi pi-plus" (click)="openAddPaymentDialog('CASH')"
		label="{{ 'modals.cashPayment.table.addCash' | translate }}" class="p-button-sm p-button-outlined"></button>
	<button type="button" pButton pRipple icon="pi pi-plus" (click)="openAddPaymentDialog('CHK')"
		label="{{ 'modals.cashPayment.table.addCheck' | translate }}" class="p-button-sm p-button-outlined"></button>
	<button type="button" pButton pRipple icon="pi pi-plus" (click)="openAddPaymentDialog('CC')"
		label="{{ 'modals.cashPayment.table.addCreditCard' | translate }}"
		class="p-button-sm p-button-outlined"></button>
	<button type="button" pButton pRipple icon="pi pi-plus" (click)="openAddPaymentDialog('BT')"
		label="{{ 'modals.cashPayment.table.addBankTransfer' | translate }}"
		class="p-button-sm p-button-outlined"></button>
	<button type="button" pButton pRipple icon="pi pi-plus" (click)="openAddPaymentDialog('DEDUCTION')"
		label="{{ 'modals.cashPayment.table.addDeduction' | translate }}" class="p-button-sm p-button-outlined"></button>
</div>

<app-cash-payment-form [lines]="paymentsGroup?.get('linesCash')" [submitted]="submitted" [debug]="debug"
	(saveLines)="onCashLinesSaved($event)">
</app-cash-payment-form>
<app-check-payment-form [lines]="paymentsGroup?.get('linesChecks')" [submitted]="submitted"
	[masterBank]="masterBankData" [allBranches]="allBranchesData" [curentLang]="curentLang" [debug]="debug"
	(saveLines)="onCheckLinesSaved($event)">
</app-check-payment-form>
<app-credit-card-payment-form [lines]="paymentsGroup?.get('linesCredit')" [submitted]="submitted"
	[curentLang]="curentLang" [debug]="debug" (saveLines)="onCreditLinesSaved($event)">
</app-credit-card-payment-form>
<app-bank-transfer-payment-form [lines]="paymentsGroup?.get('linesBankPayment')" [submitted]="submitted"
	[masterBank]="masterBankData" [curentLang]="curentLang" [debug]="debug"
	(saveLines)="onBankTransferLinesSaved($event)">
</app-bank-transfer-payment-form>
<app-deduction-payment-form [lines]="paymentsGroup?.get('linesDeduction')" [submitted]="submitted" [debug]="debug"
	(saveLines)="onDeductionLinesSaved($event)">
</app-deduction-payment-form>